module.exports = __webpack_public_path__ + "media/bootstrap-icons/stop-btn-fill-9d0ec80c.svg";